import { render } from "./ProductDetail_preview.vue?vue&type=template&id=5e4292ed"
import script from "./ProductDetail_preview.vue?vue&type=script&lang=js"
export * from "./ProductDetail_preview.vue?vue&type=script&lang=js"

import "./ProductDetail_preview.vue?vue&type=style&index=0&id=5e4292ed&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__